var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activePromotionName)?_c('banner',{attrs:{"id":_vm.activePromotionName,"show":true,"type":"notification","content":_vm.content,"event-category":"header-20190814-promotion_alert","cookie":_vm.cookie,"modifiers":['sale']}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }